export default __webpack_public_path__ + "static/media/logo_white.47bc4100.svg";